import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Nav = () => {
  const resume = "https://docs.google.com/document/d/1X2O3GGrpY8lBQ132Ipo9FG5L4bERjdcG3Xd6NmZ0K6w/edit?usp=sharing";
  const [activeNav, setActiveNav] = useState("#home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);

    // Setup Intersection Observer for scroll spy
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5, // Trigger when 50% of the section is visible
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveNav(`#${entry.target.id}`);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe sections
    const sections = ['home', 'work', 'experience', 'advocacy', 'contact'];
    sections.forEach((id) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      sections.forEach((id) => {
        const element = document.getElementById(id);
        if (element) observer.unobserve(element);
      });
    };
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Work', href: '#work' },
    { name: 'Experience', href: '#experience' },
    { name: 'Talks', href: '#advocacy' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background/80 backdrop-blur-md shadow-lg py-4' : 'bg-transparent py-6'
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex justify-between items-center">
        <div className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
          Utibe.
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex space-x-8 items-center">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={() => setActiveNav(link.href)}
              className={`text-sm font-medium transition-all px-4 py-1.5 rounded-full ${activeNav === link.href
                ? 'bg-secondary/15 text-secondary border border-secondary/30 shadow-sm'
                : 'text-slate-400 border border-transparent hover:text-white hover:bg-slate-800/50'
                }`}
            >
              {link.name}
            </a>
          ))}
          <a
            href={resume}
            target="_blank"
            rel="noreferrer"
            className="px-5 py-2.5 text-sm font-medium text-white bg-secondary/10 border border-primary/50 backdrop-blur-sm rounded-full hover:bg-primary/60 transition-all hover:scale-105 active:scale-95"
          >
            Resume
          </a>
        </div>

        {/* Mobile Nav (Bottom fixed or simple hamburger - for now just displaying links) */}
        <div className="flex md:hidden space-x-4 items-center overflow-x-auto text-sm pb-1">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={() => setActiveNav(link.href)}
              className={`font-medium transition-all px-3 py-1.5 rounded-full whitespace-nowrap ${activeNav === link.href
                ? 'bg-secondary/15 text-secondary border border-secondary/30'
                : 'text-slate-400 border border-transparent'
                }`}
            >
              {link.name}
            </a>
          ))}
          <a href={resume} target="_blank" rel="noreferrer" className="text-primary font-medium">Resume</a>
        </div>
      </div>
    </motion.nav>
  );
}

export default Nav;
